// TODO move to beam
import { TextField } from 'beam/dist/TextField'
import MaskedInput from 'react-text-mask'
import { array, bool, func } from 'prop-types'

// Masks the field input for use with dates, times, durations, phone numbers, SSNs or any other type of field that has a format that you don't want the user to be able to stray from
const MaskedTextFieldInput = ({ mask, guide, showMask, inputRef, ...others }) => (
  <MaskedInput
    {...others}
    ref={ref => {
      inputRef(ref ? ref.inputElement : null)
    }}
    mask={mask}
    guide={guide}
    showMask={showMask}
  />
)

MaskedTextFieldInput.propTypes = {
  inputRef: func.isRequired,
  mask: array.isRequired,
  showMask: bool,
  guide: bool,
}

const MaskedTextField = ({ mask, guide = false, showMask = false, ...others }) => {
  return (
    <TextField
      {...others}
      InputProps={{
        ...others.InputProps,
        inputComponent: MaskedTextFieldInput,
        inputProps: {
          mask,
          guide,
          showMask,
        },
      }}
    />
  )
}

MaskedTextField.propTypes = {
  // The mask for the field, see https://github.com/text-mask/text-mask
  mask: array.isRequired,
  // Whether the mask is shown before the user types
  guide: bool,
  showMask: bool,
}

export { MaskedTextFieldInput }
export default MaskedTextField
